export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$subscription', {
      get() {
        return this.$store.getters['subscriptions/currentSubscription']
      }
    })
  }
}
